import _asyncToGenerator from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import Toast from "../components/Toast";
import servicesUtils from "./servicesUtils";
import { getFCMToken, getPlatform, isAndroidWebView, isIOSWebView } from ".";
import Store from "./Store";
import constants from "./constants";
import { t } from "i18next";
export var registerSubscription = function registerSubscription(token) {
  var params = {
    token: token,
    platform: getPlatform()
  };
  return servicesUtils.postService("/subscription/", params).then(function () {
    return true;
  })["catch"](function () {
    Toast.error(t("unable_to_subscribe"));
    return false;
  });
};
export var unRegisterSubscription = function unRegisterSubscription(token) {
  var params = {
    token: token
  };
  return servicesUtils.postService("/subscription/delete/", params);
};
export var subscribeUserNotification = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(RNFcmToken) {
    var _token, _window, _status, _window2, _old_fcmToken, _window3, _isSuccess, _window4;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _token = RNFcmToken || null;
            if (!(!_token && !isAndroidWebView() && !isIOSWebView())) {
              _context.next = 13;
              break;
            }
            _context.next = 5;
            return (_window = window) === null || _window === void 0 || (_window = _window.Notification) === null || _window === void 0 ? void 0 : _window.requestPermission();
          case 5:
            _status = _context.sent;
            if (!(_status && _status === "granted")) {
              _context.next = 12;
              break;
            }
            _context.next = 9;
            return getFCMToken();
          case 9:
            _token = _context.sent;
            _context.next = 13;
            break;
          case 12:
            if (_status && _status === "denied") {
              Toast.warning(t("allow_browser_permission"));
            }
          case 13:
            if (!_token) {
              _context.next = 22;
              break;
            }
            _old_fcmToken = (_window2 = window) === null || _window2 === void 0 ? void 0 : _window2.localStorage.getItem(constants.PERSISTED.fcmToken);
            if (_old_fcmToken && _token != _old_fcmToken) {
              unRegisterSubscription(_old_fcmToken);
              (_window3 = window) === null || _window3 === void 0 ? void 0 : _window3.localStorage.removeItem(constants.PERSISTED.fcmToken);
            }
            _context.next = 18;
            return registerSubscription(_token);
          case 18:
            _isSuccess = _context.sent;
            if (_isSuccess) {
              (_window4 = window) === null || _window4 === void 0 ? void 0 : _window4.localStorage.setItem(constants.PERSISTED.fcmToken, _token);
            }
            if (_isSuccess && !RNFcmToken) {
              Store.update(function (s) {
                s.fcmToken = _token;
              });
            }
            return _context.abrupt("return", _isSuccess);
          case 22:
            return _context.abrupt("return", null);
          case 25:
            _context.prev = 25;
            _context.t0 = _context["catch"](0);
            console.error(_context.t0);
            return _context.abrupt("return", null);
          case 29:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 25]]);
  }));
  return function subscribeUserNotification(_x) {
    return _ref.apply(this, arguments);
  };
}();